import { useEffect, useState } from 'react';
import { api, type QueueArticleRow } from '../api';

export function ArticleQueue() {
  const [rows, setRows] = useState<QueueArticleRow[]>([]);

  useEffect(() => {
    api.articleQueue().then((result) => setRows(result.rows)).catch(() => setRows([]));
  }, []);

  return (
    <section className="panel">
      <div className="section-head">
        <h2>Article extraction queue</h2>
        <span>{rows.length} pending or failed</span>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Outlet</th>
              <th>Status</th>
              <th>Published</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td><a href={row.url}>{row.title ?? row.url}</a></td>
                <td>{row.outlet ?? 'Unknown'}</td>
                <td><span className={`badge ${row.fetch_status}`}>{row.fetch_status}</span></td>
                <td>{row.publish_date ?? 'Unknown'}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={4}>No queued articles yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
